import React from 'react'
import LeftBar from '../../Components/LeftBar'
import Dashnav from '../../Components/Dashnav'
import VendorsComp from './VendorsComp'

function Vendors() {
  return (
    <div className='mainContainer'>
        <LeftBar/>
        <div className='theMainContainer'>
            <Dashnav/>
            <VendorsComp/>      
        </div> 
    </div>
  )
}

export default Vendors